import { Page } from '../../components';
import FormsMapperList from './FormsMapperList';

const FormsMapperListPage = () => {
  return (
    <Page
      documentName="Inspection Report Template Mapper"
      pageName="Inspection Report Template Mapper - List"
      path="/report_template_mapper/list"
    >
      <FormsMapperList />
    </Page>
  );
};

export default FormsMapperListPage;
